import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/contexts/AuthContext";
import { loadSupabase } from "@/lib/loadSupabase";

export function useIsAdmin() {
  const { user, loading: authLoading } = useAuth();

  const { data: isAdmin, isLoading, isError } = useQuery({
    queryKey: ["user_roles", "admin", user?.id],
    queryFn: async () => {
      if (!user) return false;
      const supabase = await loadSupabase();
      const { data, error } = await supabase
        .from("user_roles")
        .select("role")
        .eq("user_id", user.id)
        .eq("role", "admin")
        .maybeSingle();
      if (error) throw error;
      return Boolean(data);
    },
    enabled: Boolean(user),
  });

  return { isAdmin: isAdmin ?? false, isLoading: authLoading || (Boolean(user) && isLoading), isError };
}
